import { Image, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { Z_INDEX } from '@hero/constants';

const InputsWrapper = styled.div`
  background-image: url(${({ src }) => src});
  background-size: 100%;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  display: flex;
  height: 100%;
  justify-content: center;
  margin: 43px auto 0;
  padding: 16px;
  width: 100%;
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  width: 100%;

  .branding-image {
    height: 80px;
    width: 80px;
  }
`;

const LogoPlaceholder = styled.div`
  align-items: center;
  border: 3px dashed var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  display: flex;
  height: 48px;
  justify-content: center;
  width: 195px;
`;

const SenderNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 8px;
  word-break: break-all;
`;

const PreviewWrapper = styled.div`
  -ms-overflow-style: none;
  align-items: center;
  background-color: var(--color-bg-body);
  border-radius: var(--size-border-radius-md);
  box-shadow: var(--shadow-m);
  display: flex;
  flex-direction: column;
  height: 100%; /* IE and Edge */
  justify-content: start; /* IFirefox */
  overflow: auto;
  padding: 16px;
  scrollbar-width: none;
  width: 100%;

  &::-webkit-scrollbar {
    display: none; /* Chrome Safari Opera */
  }
`;

const GiftMessageWrapper = styled.div`
  align-items: center;
  background-color: rgba(242, 240, 241, 1);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-grow: 1;
  height: 150px;
  justify-content: center;
  margin-bottom: 16px;
  margin-top: 16px;
  overflow-y: auto;
  padding: 8px;
  width: 100%;
  word-break: break-word;

  ul li {
    list-style-type: disc;
    margin-left: 6px;
  }

  ol li {
    list-style-type: decimal;
    margin-left: 6px;
  }
`;

const GiftMessageText = styled(Typography)`
  color: var(--color-fg-weak);
  font-size: 10px;
  line-height: 150%;
  text-align: center;
`;

const CorporateIcons = styled(Image)`
  left: 77%;
  position: absolute;
  top: 80px;
  transform: translate(-50%, 0);
  width: 12px;
  z-index: ${Z_INDEX.iphoneHeaderIcons};
`;

const ButtonsWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export {
  ButtonsWrapper,
  CorporateIcons,
  GiftMessageText,
  GiftMessageWrapper,
  InputsWrapper,
  LogoPlaceholder,
  LogoWrapper,
  PreviewWrapper,
  SenderNameWrapper
};
